function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import olFormatGeoJSON from 'ol/format/GeoJSON';
import olFeature from 'ol/Feature';
import olRenderFeature from 'ol/render/Feature';
import { fromExtent } from 'ol/geom/Polygon';
import { HoverHandler } from './HoverHandler';
import { LAYER_ID, LAYER_TYPE, FTR_PROPERTY_ID, VECTOR_TYPE, SERVICE_HOVER, SERVICE_CLICK, SERVICE_LAYER_REQUEST } from '../domain/constants';

/**
 * @class Oskari.mapframework.service.VectorFeatureService
 *
 * Handles map click and hover on VectorFeatures.
 * Handles layer configuration requests.
 */
Oskari.clazz.defineES('Oskari.mapframework.service.VectorFeatureService', /*#__PURE__*/function () {
  function VectorFeatureService(sandbox, mapmodule) {
    _classCallCheck(this, VectorFeatureService);
    this.__name = 'VectorFeatureService';
    this.__qname = 'Oskari.mapframework.service.VectorFeatureService';
    this._log = Oskari.log('VectorFeatureService');
    this._sandbox = sandbox;
    this._map = mapmodule.getMap();
    this._mapmodule = mapmodule;
    this._featureFormatter = new olFormatGeoJSON();
    this.layerTypeHandlers = {};
    this.defaultHandlers = {};
    this.hoverHandler = new HoverHandler(mapmodule);
    this._hoverEnabled = true;
    this._registerEventHandlers();
  }

  /**
   * @method _registerEventHandlers
   * Registers as handler for click and hover events.
   */
  return _createClass(VectorFeatureService, [{
    key: "_registerEventHandlers",
    value: function _registerEventHandlers() {
      this._sandbox.registerForEventByName(this, 'MouseHoverEvent');
      this._sandbox.registerForEventByName(this, 'MapClickedEvent');
      this._sandbox.registerForEventByName(this, 'MapLayerVisibilityChangedEvent');
      this._sandbox.registerForEventByName(this, 'AfterChangeMapLayerOpacityEvent');
      this._sandbox.registerForEventByName(this, 'AfterChangeMapLayerStyleEvent');
      this._sandbox.registerForEventByName(this, 'AfterMapLayerRemoveEvent');
    }

    /**
     * @method getQName
     * @return {String} fully qualified name for service
     */
  }, {
    key: "getQName",
    value: function getQName() {
      return this.__qname;
    }

    /**
     * @method getName
     * @return {String} service name
     */
  }, {
    key: "getName",
    value: function getName() {
      return this.__name;
    }

    /**
     * @method getSandbox
     * @return {Oskari.Sandbox}
     */
  }, {
    key: "getSandbox",
    value: function getSandbox() {
      return this._sandbox;
    }

    /**
     * @method registerLayerType
     *
     * Registers layer type so layers of the type receive click and hover events and layer requests.
     * Performs common tasks on events. For ex. displaying tooltip and dispatching feature click events.
     *
     * @param { String} layerType
     * @param {Object} handlerImpl Object that contains handler functions onMapClicked, onMapHover or onLayerRequest | optional
     * @param {Array<String>} defaultHandlerDef Array of handler types ("click", "hover", "layerRequest")
     *  to be used as default handlers | optional
     */
  }, {
    key: "registerLayerType",
    value: function registerLayerType(layerType, handlerImpl, defaultHandlerDef) {
      var _this = this;
      if (!layerType) {
        return;
      }
      var layerTypeHandlers = this.layerTypeHandlers[layerType];
      if (!layerTypeHandlers) {
        layerTypeHandlers = {};
        this.layerTypeHandlers[layerType] = layerTypeHandlers;
      }
      if (handlerImpl) {
        if (typeof handlerImpl.onMapClicked === 'function') {
          layerTypeHandlers[SERVICE_CLICK] = handlerImpl.onMapClicked.bind(handlerImpl);
        }
        if (typeof handlerImpl.onMapHover === 'function') {
          layerTypeHandlers[SERVICE_HOVER] = handlerImpl.onMapHover.bind(handlerImpl);
        }
        if (typeof handlerImpl.onLayerRequest === 'function') {
          layerTypeHandlers[SERVICE_LAYER_REQUEST] = handlerImpl.onLayerRequest.bind(handlerImpl);
        }
        if (Array.isArray(defaultHandlerDef)) {
          defaultHandlerDef.forEach(function (handlerType) {
            _this.defaultHandlers[handlerType] = layerTypeHandlers[handlerType];
          });
        }
      }
    }
  }, {
    key: "registerDefaultStyles",
    value: function registerDefaultStyles(layerType) {
      var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!layerType) {
        return;
      }
      var style = styles.style,
        hover = styles.hover;
      if (style) {
        this.hoverHandler.setDefaultStyle(layerType, 'featureStyle', style);
      }
      if (hover) {
        this.hoverHandler.setDefaultStyle(layerType, 'hover', hover);
      }
    }

    /**
     * @method _getRegisteredHandler
     * @param {String} layerType
     * @param {String} handlerType
     * @returns Registered handler function for layer type or null
     */
  }, {
    key: "_getRegisteredHandler",
    value: function _getRegisteredHandler(layerType, handlerType) {
      if (layerType && handlerType) {
        var layerTypeHandlers = this.layerTypeHandlers[layerType];
        var handler = layerTypeHandlers ? layerTypeHandlers[handlerType] : null;
        if (typeof handler === 'function') {
          return handler;
        }
      }
    }

    /**
     * @method _getDefaultHandler
     * @param {String} handlerType
     * @returns Default handler function for handlerType or null
     */
  }, {
    key: "_getDefaultHandler",
    value: function _getDefaultHandler(handlerType) {
      if (handlerType) {
        var handler = this.defaultHandlers[handlerType];
        if (typeof handler === 'function') {
          return handler;
        }
      }
    }

    /**
     * @method handleVectorLayerRequest
     * Passes the request to a proper layer handler
     *
     * @param {Oskari.mapframework.bundle.mapmodule.request.VectorLayerRequest} request
     */
  }, {
    key: "handleVectorLayerRequest",
    value: function handleVectorLayerRequest(request) {
      var layerId = request.getOptions().layerId;
      var defaultHandler = this._getDefaultHandler(SERVICE_LAYER_REQUEST);
      if (!layerId) {
        if (defaultHandler) {
          defaultHandler(request);
        }
        return;
      }
      var mapLayerService = this.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
      if (mapLayerService) {
        var layer = mapLayerService.findMapLayer(layerId);
        var handler = layer ? this._getRegisteredHandler(layer.getLayerType(), SERVICE_LAYER_REQUEST) : defaultHandler;
        if (handler) {
          handler(request, layer);
        }
      }
    }

    /**
     * @method _onlyRegisteredTypesFilter
     * Filter function to filter only registered layer types
     * @param {olLayer} layer
     * @return {boolean} true if layer's type is registered.
     */
  }, {
    key: "_onlyRegisteredTypesFilter",
    value: function _onlyRegisteredTypesFilter(layer) {
      var layerType = layer.get(LAYER_TYPE);
      return layerType && !!this.layerTypeHandlers[layerType];
    }

    /**
     * @method _getTopmostFeatureAndLayer
     * @param {Oskari.mapframework.event.common.MouseHoverEvent} event
     * @return {Object} Object containing the topmost feature and it's layer on the mouse location.
     * An empty object if features were not found.
     */
  }, {
    key: "_getTopmostFeatureAndLayer",
    value: function _getTopmostFeatureAndLayer(event) {
      var _this2 = this;
      var pixel = [event.getPageX(), event.getPageY()];
      var featureHitCb = function featureHitCb(feature, layer) {
        return {
          feature: feature,
          layer: layer
        };
      };
      try {
        return this._map.forEachFeatureAtPixel(pixel, featureHitCb, {
          layerFilter: function layerFilter(layer) {
            return _this2._onlyRegisteredTypesFilter(layer);
          }
        }) || {};
      } catch (ex) {
        if (ex.message === "Cannot read property 'forEachFeatureAtCoordinate' of undefined") {
          this._log.debug('Could not find features at hover location. Omitted ol renderer error:\n', ex);
        } else {
          throw ex;
        }
      }
      return {};
    }

    /**
     * @method _onMapHover
     * Finds the topmost feature from the layers controlled by the service and handles hover tooltip for the feature.
     *
     * @param {Oskari.mapframework.event.common.MouseHoverEvent} event
     */
  }, {
    key: "_onMapHover",
    value: function _onMapHover(event) {
      // don't hover while drawing
      if (event.isDrawing()) {
        return;
      }
      if (this._sandbox.getMap().isMoving()) {
        return;
      }
      if (this._hoverEnabled) {
        this.hoverHandler.onMapHover(event);
        this._hoverFeature(event);
      }
    }
  }, {
    key: "_hoverFeature",
    value: function _hoverFeature(event) {
      var _this$_getTopmostFeat = this._getTopmostFeatureAndLayer(event),
        feature = _this$_getTopmostFeat.feature,
        layer = _this$_getTopmostFeat.layer;
      if (feature && layer) {
        if (feature && feature.get('features')) {
          // Cluster source
          if (feature.get('features').length > 1) {
            return;
          }
          // Single feature
          feature = feature.get('features')[0];
        }
      }
      // Vectorhandler updates vector layers' feature styles but tooltip is handled by hoverhandler
      var vectorHandler = this._getRegisteredHandler(VECTOR_TYPE, SERVICE_HOVER);
      vectorHandler(event, feature, layer);
      this.hoverHandler.onFeatureHover(event, feature, layer);
    }

    /**
     * @method registerHoverLayer
     * Register layer and hover style for ol/layer/Vector
     * Create and return hover layer for ol/source/VectorTile
     *
     * @param {OskariLayer} layer
     * @param {ol/source/VectorTile} source for VectorTile layers
     * @return ol/source/VectorTile for VectorTile layers
     */
  }, {
    key: "registerHoverLayer",
    value: function registerHoverLayer(layer, source) {
      if (source) {
        return this.hoverHandler.createVectorTileLayer(layer, source);
      }
      this.hoverHandler.registerLayer(layer);
    }
  }, {
    key: "setVectorLayerHoverTooltip",
    value: function setVectorLayerHoverTooltip(layer) {
      this.hoverHandler.setTooltipContent(layer);
    }

    /**
     * @method _getGeojson
     *
     * Returns geojson for feature.
     * If the feature is read-only (olRenderFeature), creates a geojson of the feature's extent.
     *
     * @param {olFeature | olRenderFeature} feature
     * @return geojson
     */
  }, {
    key: "_getGeojson",
    value: function _getGeojson(feature) {
      if (feature instanceof olRenderFeature) {
        var polygon = fromExtent(feature.getExtent());
        var ftr = new olFeature(polygon);
        ftr.setProperties(feature.getProperties());
        return this._featureFormatter.writeFeaturesObject([ftr]);
      } else {
        return this._featureFormatter.writeFeaturesObject([feature]);
      }
    }

    /**
     *  @method _onMapClicked
     * Find features from the layers controlled by the service and handle clicks for all those features.
     * Calls registered click handlers.
     *
     * @param {Oskari.mapframework.bundle.mapmodule.event.MapClickedEvent} event
     */
  }, {
    key: "_onMapClicked",
    value: function _onMapClicked(event) {
      var me = this;
      var clickHits = [];
      this._mapmodule.forEachFeatureAtPixel([event.getMouseX(), event.getMouseY()], function (feature, layer) {
        if (!layer) {
          return;
        }
        if (feature.get('features')) {
          // Cluster source
          if (feature.get('features').length > 1) {
            return;
          }
          // Single feature
          feature = feature.get('features')[0];
        }
        var layerType = layer.get(LAYER_TYPE);
        var isRegisteredLayerType = layerType && me.layerTypeHandlers[layerType];
        if (isRegisteredLayerType) {
          var handler = me._getRegisteredHandler(layerType, SERVICE_CLICK);
          if (handler) {
            handler(event, feature, layer);
          }
          clickHits.push({
            feature: feature,
            layer: layer
          });
        }
      });
      if (clickHits.length > 0) {
        var clickEvent = Oskari.eventBuilder('FeatureEvent')().setOpClick();
        clickHits.forEach(function (obj) {
          var feature = obj.feature,
            layer = obj.layer;
          var geojson = me._getGeojson(feature, layer);
          var propertyId = feature.get(FTR_PROPERTY_ID);
          var layerId = layer.get(LAYER_ID);
          clickEvent.addFeature(propertyId, geojson, layerId);
        });
        me.getSandbox().notifyAll(clickEvent);
      }
    }
  }, {
    key: "setHoverEnabled",
    value: function setHoverEnabled(bln) {
      this._hoverEnabled = !!bln;
    }

    /**
     * @public @method onEvent
     * Event is handled forwarded to correct #eventHandlers if found or
     * discarded* if not.
     *
     * @param {Oskari.mapframework.event.Event} event a Oskari event object
     */
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      switch (event.getName()) {
        case 'MouseHoverEvent':
          this._onMapHover(event);
          break;
        case 'MapClickedEvent':
          this._onMapClicked(event);
          break;
        case 'MapLayerVisibilityChangedEvent':
          this.hoverHandler.updateHoverLayer(event.getMapLayer(), !event.isInScale() || !event.isGeometryMatch());
          break;
        case 'AfterChangeMapLayerOpacityEvent':
          this.hoverHandler.updateHoverLayer(event.getMapLayer());
          break;
        case 'AfterChangeMapLayerStyleEvent':
          this.hoverHandler.updateLayerStyle(event.getMapLayer());
          break;
        case 'AfterMapLayerRemoveEvent':
          this.hoverHandler.removeLayer(event.getMapLayer());
          break;
      }
    }
  }]);
}(), {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  'protocol': ['Oskari.mapframework.service.Service']
});